"use client";
import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { component } from "@gnist/component-utils";
import { loadingSpinnerStyle } from "./loadingSpinner.css.js";
const Spinner = component("Spinner", loadingSpinnerStyle, "div");
const LoadingSpinner = ({ isFullScreen = false, withoutDelay = false, delegated }) => {
  const [showSpinner, setShowSpinner] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSpinner(true);
    }, withoutDelay ? 0 : 500);
    return () => {
      clearTimeout(timeout);
    };
  }, [withoutDelay]);
  if (!showSpinner) {
    return null;
  }
  return jsx("div", { style: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: isFullScreen ? "80vh" : "auto"
  }, children: jsx(Spinner, { ...delegated }) });
};
export {
  LoadingSpinner
};
